import config from 'config-base';

import ApiClient from '@/lib/ApiClient';

export const apiClient = new ApiClient(config.apiClientSideUrl, config.apiServerSideUrl);
